export default __webpack_public_path__ + "assets/images/955f0f316c07452427eaf4ae8410edfc.png";